import { render, staticRenderFns } from "./jobItem.vue?vue&type=template&id=8ecd6840&scoped=true"
import script from "./jobItem.vue?vue&type=script&lang=js"
export * from "./jobItem.vue?vue&type=script&lang=js"
import style0 from "./jobItem.vue?vue&type=style&index=0&id=8ecd6840&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecd6840",
  null
  
)

export default component.exports